import React from 'react';

const LogFile = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.41309
                2.5H15.0576L15.1406
                2.50488C15.3308
                2.52466
                15.5095
                2.60928
                15.6455
                2.74609L17.2549
                4.35547C17.4042
                4.50372
                17.4915
                4.70286
                17.5
                4.91309V14.2266C17.5
                14.4476
                17.4121
                14.6601
                17.2559
                14.8164C17.0997
                14.9724
                16.8878
                15.0595
                16.667
                15.0596H12.0508C12.0787
                14.958
                12.1047
                14.8559
                12.127
                14.7529H16.333C16.554
                14.7529
                16.7666
                14.6651
                16.9229
                14.5088C17.0789
                14.3525
                17.167
                14.1408
                17.167
                13.9199V5.08008C17.1674
                4.9968
                17.1545
                4.91419
                17.1299
                4.83496L17.1006
                4.75586L17.0635
                4.67969C17.0358
                4.63019
                17.0031
                4.58371
                16.9658
                4.54102L16.9072
                4.48047L15.5068
                3.08008C15.4518
                3.02342
                15.3891
                2.97492
                15.3203
                2.93652L15.2441
                2.89941L15.165
                2.87012C15.0858
                2.84551
                15.0032
                2.8326
                14.9199
                2.83301H7.74707C7.52606
                2.83301
                7.31351
                2.92087
                7.15723
                3.07715C7.00095
                3.23343
                6.91309
                3.44598
                6.91309
                3.66699V7.78418C6.79797
                7.7767
                6.68423
                7.77273
                6.58008
                7.77051V3.33301C6.58016
                3.11211
                6.66802
                2.90034
                6.82422
                2.74414C6.98042
                2.58794
                7.19219
                2.50009
                7.41309
                2.5Z"
                fill="#595959"
                stroke="#595959"
                />
            <path
                d="M6.5
                9C5.60999
                9
                4.73996
                9.26392
                3.99994
                9.75839C3.25991
                10.2529
                2.68314
                10.9557
                2.34254
                11.7779C2.00195
                12.6002
                1.91283
                13.505
                2.08647
                14.3779C2.2601
                15.2508
                2.68869
                16.0526
                3.31802
                16.682C3.94736
                17.3113
                4.74918
                17.7399
                5.62209
                17.9135C6.49501
                18.0872
                7.39981
                17.9981
                8.22208
                17.6575C9.04434
                17.3169
                9.74715
                16.7401
                10.2416
                16.0001C10.7361
                15.26
                11
                14.39
                11
                13.5C10.9982
                12.3071
                10.5236
                11.1635
                9.68003
                10.32C8.8365
                9.47644
                7.69293
                9.00176
                6.5
                9ZM6.5
                16.6667C5.87369
                16.6667
                5.26145
                16.4809
                4.7407
                16.133C4.21994
                15.785
                3.81406
                15.2905
                3.57438
                14.7118C3.33471
                14.1332
                3.272
                13.4965
                3.39418
                12.8822C3.51637
                12.2679
                3.81796
                11.7037
                4.26083
                11.2608C4.7037
                10.818
                5.26794
                10.5164
                5.88222
                10.3942C6.49649
                10.272
                7.1332
                10.3347
                7.71183
                10.5744C8.29046
                10.8141
                8.78503
                11.2199
                9.13299
                11.7407C9.48095
                12.2614
                9.66667
                12.8737
                9.66667
                13.5C9.66667
                13.9159
                9.58476
                14.3276
                9.42562
                14.7118C9.26648
                15.096
                9.03322
                15.4451
                8.73917
                15.7392C8.44512
                16.0332
                8.09603
                16.2665
                7.71183
                16.4256C7.32763
                16.5848
                6.91585
                16.6667
                6.5
                16.6667Z"
                fill="#595959"
                />
            <path
                d="M7.83301
                12.8332H7.33301C7.2888
                12.8332
                7.24641
                12.8157
                7.21516
                12.7844C7.1839
                12.7532
                7.16634
                12.7108
                7.16634
                12.6666V11.8332C7.16634
                11.6564
                7.0961
                11.4869
                6.97108
                11.3618C6.84605
                11.2368
                6.67649
                11.1666
                6.49967
                11.1666C6.32286
                11.1666
                6.15329
                11.2368
                6.02827
                11.3618C5.90325
                11.4869
                5.83301
                11.6564
                5.83301
                11.8332V13.4999C5.83301
                13.6767
                5.90325
                13.8463
                6.02827
                13.9713C6.15329
                14.0963
                6.32286
                14.1666
                6.49967
                14.1666H7.83301C8.00982
                14.1666
                8.17939
                14.0963
                8.30441
                13.9713C8.42944
                13.8463
                8.49967
                13.6767
                8.49967
                13.4999C8.49967
                13.3231
                8.42944
                13.1535
                8.30441
                13.0285C8.17939
                12.9035
                8.00982
                12.8332
                7.83301
                12.8332Z"
                fill="#595959" />
        </svg>
    );
};

export default LogFile;
